import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { NAME } from './constants';
import * as actionTypes from './actionTypes';

const initialState = {
    token: null,
    tokenTtl: null,
    authorizing: false,
    paramsToken: null,
    redirectToOld: null,
    serverUrl: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTHORIZE_BY_APPLICATION.REQUEST:
            return {
                ...state,
                authorizing: true,
                paramsToken: action.payload
            };
        case actionTypes.AUTHORIZE_BY_APPLICATION.SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                serverUrl: action.payload.server,
                tokenTtl: action.payload.ttl,
                redirectToOld: action.payload.redirectToOld,
                authorizing: false
            };
        case actionTypes.AUTHORIZE_BY_APPLICATION.ERROR:
            return {
                ...state,
                token: null,
                tokenTtl: null,
                redirectToOld: null,
                authorizing: false,
                serverUrl: null
            };
        case actionTypes.GET_TOKEN.SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                authorizing: true
            }
        default:
            return state;
    }
};

const persistConfig = {
    key: NAME,
    storage,
    whitelist: []
};

export default persistReducer(persistConfig, reducer);